import React from 'react'
import {useCustomerFromRoute} from '@oc/shell-core'

const SelectedRkContext = React.createContext<[string, (next: string) => void]>([
    '',
    () => {
        /*do nothing*/
    }
])

export const SelectedRkContextProvider = ({children}: React.PropsWithChildren) => {
    const {rkId} = useCustomerFromRoute()
    const state = React.useState(() => rkId || '')

    return <SelectedRkContext.Provider value={state}>{children}</SelectedRkContext.Provider>
}

export const useSelectedRkContext = (): [string, (next: string) => void] => React.useContext(SelectedRkContext)

export const useSelectedRkContextSetter = (): ((next: string) => void) => React.useContext(SelectedRkContext)[1]
